import { configureStore } from "@reduxjs/toolkit";
import { api } from "../services/apis";
import authReducer, { clearTokens, setTokens } from "../services/authSlice";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { scryptx } from "./localStorage";
import { status } from "./helper";

const customMiddleware = (storeAPI) => (next) => (action) => {
  if (action.error && action.payload?.originalStatus === 401) {
    toast.error("Unauthorized access detected, please login again");
    storeAPI.dispatch(clearTokens());
    window.location.href = "/login";
    return;
  }
  return next(action);
};

let refreshStatus = status.OKAY; // 0 = failed, 1 = all okay, 2 = in progress

const apiMiddleware = (store) => (next) => async (action) => {
  const token = scryptx.getObject('token');
  if (!token?.accessToken) return next(action);
  try {
    const tokenObj = jwtDecode(token?.accessToken);
    const refreshTokenObj = jwtDecode(token?.refreshToken);

    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds since Unix epoch
    const activeTokenExpiry = Math.floor((tokenObj.exp - currentTime) / 60); // Token expiry in minutes
    const refreshTokenExpiry = Math.floor((refreshTokenObj.exp - currentTime) / 60); // Refresh token expiry in minutes

    if (
      tokenObj &&
      refreshStatus === status.OKAY &&
      activeTokenExpiry <= status.FAILED &&
      refreshTokenExpiry > status.FAILED
    ) {
      refreshStatus = status.IN_PROGRESS;
      fetch(`${process.env.REACT_APP_API_BASE}/auth/p/token-management/refresh?refresh-token=${token.refreshToken}`, {
        method: 'POST',
        headers: {
          "Accept": 'application/json',
        }
      })
        .then(async (rawResponse) => {
          const data = await rawResponse.json();
          store.dispatch(setTokens(data));
          next(action);
          refreshStatus = status.OKAY;
        })
        .catch((e) => {
          console.error(e);
          refreshStatus = status.FAILED;
          next(action);
        });
    } else {
      next(action);
    }
  } catch (e) {
    console.error(e);
    store.dispatch(clearTokens());
  }
};


export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(api.middleware, customMiddleware, apiMiddleware),
});
